import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import { useRefresh } from 'context/RefreshProvider/RefreshProvider';
import useFetchData from 'hooks/useFetchData';
import { DRAFTS_COUNT_API_URL } from 'utils/defaults';

type TDraftsCount = {
  count: number;
};

const useDraftsCount = (isSignedIn: boolean) => {
  const { getData } = useFetchData();
  const { refreshToggle } = useRefresh();
  const location = useLocation();
  const [draftsCount, setDraftsCount] = useState<number>(0);

  useEffect(() => {
    const getDraftsCount = async () => {
      await getData<TDraftsCount>(DRAFTS_COUNT_API_URL, (data) => {
        setDraftsCount(data.count);
      });
    };

    if (isSignedIn) {
      getDraftsCount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSignedIn, location.pathname, refreshToggle]);

  return draftsCount;
};

export default useDraftsCount;
